webpackJsonp([222060369147635],{

/***/ 1436:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"EventMetadataFilter","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"value","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-event-metadata-filter-e58ac9290dd8a2291e7e.js